import axios from 'axios';

const getList = params => axios.get('/tipos-uso', {
  params,
});

export default {
  getList,
};
